"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import dynamic from "next/dynamic";

const RegisterPage = dynamic(() => import("@/app/register/page"), {
  ssr: false,
});

export default function LocaleRegisterPage() {
  const pathname = usePathname();
  const locale = pathname?.split("/")[1] || "zh";

  // Store locale in sessionStorage for RegisterPage to access
  useEffect(() => {
    if (typeof window !== "undefined") {
      sessionStorage.setItem("app_locale", locale);
    }
  }, [locale]);

  return <RegisterPage />;
}
